export default "__VITE_ASSET__932fba14__"